@if (userService.organization()) {
  @if (sharedService.screenSize !== 's' || menuDrawerVisible) {
    <blu-nav-bar (close)="menuDrawerVisible = false"></blu-nav-bar>
  }
  <section
    class="relative flex flex-col items-center w-full p-5 gap-5 overflow-hidden box-border"
  >
    <!-- splash -->
    <div
      class="absolute top-0 left-0 w-full h-80 -z-10"
      style="
        background: linear-gradient(135deg, rgb(20 51 93), rgb(11 23 40) 50%);
      "
    ></div>

    <!-- header -->
    <blu-header theme="dark">
      @if (sharedService.screenSize === 's') {
        <button
          class="px-1"
          (click)="
            menuDrawerVisible = true;
            analyticsService.logEvent('admin_header_menu_icon_click')
          "
        >
          <span class="material-symbols-rounded">menu</span>
        </button>
      }
    </blu-header>
    @for (announcement of announcements()(); track $index) {
      <blu-announcement
        class="text-white w-full max-w-screen-lg"
        [announcement]="announcement"
      ></blu-announcement>
    }
    <router-outlet></router-outlet>
  </section>
}

<router-outlet name="modal"></router-outlet>
